import React, { Component } from 'react';
import { connect } from 'react-redux';
import './InToast.css';
import actions from '../../store/actions';

class InToast1 extends Component {
  constructor(props) {
    super(props);
    this.toastRef = React.createRef();
    [
      'close',
      'getToasts',
      'processToasts',
      'autoClose',
      'closeToast',
      'closeLocationToast',
      'gotoMap',
      'handleCopy',
      'hideNotification',
      'handleClickOutside'
    ].forEach(method => (this[method] = this[method].bind(this)));
  }

  state = {
    hideNonLocation: false,
    animate: false,
    popout: false,
    hasLocationAlert: false
  };

  latestAlertTime = 0;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  // handleClickOutside(event) {
  //   if (!this.toastRef.current?.contains(event.target)) {
  //     const { location } = this.getToasts();
  //     if (location.length > 0) {
  //       this.closeLocationToast(location[0]); // Only closes location toasts
  //     }
  //     // Do NOT modify regular toasts here
  //   }
  // }
  handleClickOutside(event) {
    if (this.toastRef.current &&
    !this.toastRef.current.contains(event.target)) {
    const { location } = this.getToasts();
    if (location.length > 0) {
    this.closeLocationToast(location[0]);
    }
    }
    }

  close() {
    // Placeholder for close functionality
  }

  getToasts() {
    const regularToasts = this.props.InToast?.data || [];
    const locationToasts = this.props.InToastLocation?.data || [];
    
    return {
      regular: regularToasts,
      location: locationToasts
    };
  }

  hideNotification() {
    this.setState(prevState => ({ 
      hideNonLocation: !prevState.hideNonLocation 
    }));
  }

  autoClose(toast) {
    setTimeout(() => {
      if (toast.viewInMap) {
        this.closeLocationToast(toast);
      } else {
        this.closeToast(toast);
      }
    }, toast.autoClose);
  }

  gotoMap(item) {
    if (item.lat && item.lng) {
      window.showInGoogleMaps(item.lat, item.lng);
    }
  }

  closeToast(toast) {
    const newData = this.props.InToast.data.filter(
      t => t.createAt !== toast.createAt
    );
    this.props.dispatch({
      type: actions.UPDATE_INTOAST_LIST,
      data: newData
    });
  }

  closeLocationToast(toast) {
    // const newData = this.props.InToastLocation.data.filter(
    //   t => t.createAt !== toast.createAt
    // );
    this.props.dispatch({
      type: actions.UPDATE_INTOAST_LOCATION_LIST,
      data: []
    });
  }

  handleCopy(item) {
    if (item.lat && item.lng) {
      const url = `https://www.google.com/maps?q=${item.lat},${item.lng}`;
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Copy failed:', err);
      }
      document.body.removeChild(textarea);
    }
  }

  processToasts(toasts) {
    this.setState({ animate: false });
    setTimeout(() => {
      this.setState({ animate: true });
    }, 100);

    toasts.forEach(toast => {
      if (!toast.processed) {
        toast.processed = true;
        this.latestAlertTime = Math.max(toast.createAt, this.latestAlertTime);
        if (toast.autoClose) {
          this.autoClose(toast);
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { InToast, InToastLocation } = this.props;
    
    if (InToast.updatedAt !== prevProps.InToast.updatedAt) {
      this.processToasts(InToast.data);
      this.setState({ popout: true });
      setTimeout(() => {
        this.setState({ popout: false });
      }, 300);
    }
    
    if (InToastLocation.updatedAt !== prevProps.InToastLocation.updatedAt) {
      this.processToasts(InToastLocation.data);
      this.setState({ 
        popout: true,
        hasLocationAlert: InToastLocation.data.length > 0
      });
      setTimeout(() => {
        this.setState({ popout: false });
      }, 300);
    }
  }

  getInToastClassName() {
    let className = 'InToast ';
    if (this.props.reportWindow.visible && this.props.reportWindow.tab?.key) {
      className += `reportWindow ${this.props.reportWindow.tab.key}`;
    }
    return className;
  }

  sort(a, b) {
    return b.createAt - a.createAt;
  }

  isNewToast(toast) {
    if (toast.createAt >= this.latestAlertTime && !toast.onceIWasNew) {
      toast.onceIWasNew = true;
      return true;
    }
    return false;
  }
  filterDataByAge(data) {
    const now = new Date();
    const threeDaysAgo = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000);
    const filteredData = data.filter(item => item.createAt >= threeDaysAgo.getTime());
    return filteredData;
  }

  render() {
    const { regular, location } = this.getToasts();
    const regularAlert=this.filterDataByAge(regular)
    const sortedRegular = [...regularAlert].sort(this.sort);
    const sortedLocation = [...location].sort(this.sort);
    
    // Show the most recent location toast if any
    const currentLocationToast = sortedLocation[0];
    
    // Maximum 5 regular alerts
    const maxRegularToShow = currentLocationToast ? 5 : 5;
    // const visibleRegularToasts = this.state.hideNonLocation
    //   ? []
    //   : sortedRegular.slice(0, maxRegularToShow);
    const alwaysVisibleAlerts = sortedRegular.filter(item => item.showError);
const hideableAlerts = sortedRegular.filter(item => !item.showError);

const visibleRegularToasts = this.state.hideNonLocation
  ? alwaysVisibleAlerts
  : [...alwaysVisibleAlerts, ...hideableAlerts.slice(0, maxRegularToShow - alwaysVisibleAlerts.length)];

    // Combine location and regular alerts, but limit to 6 total (5 regular + 1 location)
    const toastsToShow = currentLocationToast
      ? [currentLocationToast, ...visibleRegularToasts].slice(0, 6)
      : visibleRegularToasts;

    // Calculate how many regular alerts are hidden
    const hiddenRegularCount = this.state.hideNonLocation
      ? sortedRegular.length
      : Math.max(0, sortedRegular.length - maxRegularToShow);

    // Only show counter if there are hidden regular alerts
    const shouldShowCounter = hiddenRegularCount > 3;

    return (
      <div className={this.getInToastClassName()} ref={this.toastRef}>
        {toastsToShow.map((item, index) => (
          <div
            key={`${item.createAt}-${index}`}
            className={`it-container ${
              index === 0 && !this.state.popout && this.isNewToast(item)
                ? this.state.animate
                  ? ' anim'
                  : ' noanim'
                : ''
            }
              ${(item.viewInMap || this.isNewToast(item) || item.showError) ? ' newitem' : ''}`}
          >
            <div className="itc-head">
              <div className="itch-name">{item.name}</div>
              {item.viewInMap && (
                <>
                  <div 
                    className="itch-viewInmap" 
                    onClick={() => this.gotoMap(item)}
                  >
                    Show on map
                  </div>
                  <span 
                    className="itch-copy" 
                    onClick={() => this.handleCopy(item)}
                  >
                    <i className="fa fa-clone" aria-hidden="true"></i>
                  </span>
                </>
              )}
              <div 
                className="itch-close" 
                onClick={() => item.viewInMap 
                  ? this.closeLocationToast(item) 
                  : this.closeToast(item)}
              >
                <i className="fa fa-times"></i>
              </div>
            </div>
            <div className="itc-body">{item.content}</div>
          </div>
        ))}

        {shouldShowCounter && (
          <div className="it-container">
            <div 
              className="itc-head" 
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div className="itch-name">
                {/* {hiddenRegularCount} more notification
                {hiddenRegularCount !== 1 ? 's' : ''} */}
                <div className="itch-name">
                {this.state.hideNonLocation
                  ? `${hiddenRegularCount> 5 ? 5:hiddenRegularCount} hidden notification${visibleRegularToasts.length !== 1 ? 's' : ''}`
                  : '0 hidden notification'}
              </div>
              </div>
              <div className="itch-hide">
                <button onClick={this.hideNotification}>
                  {this.state.hideNonLocation 
                    ? 'Show notifications' 
                    : 'Hide notifications'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );

  }
}

const mapStateToProps = (state) => ({
  InToast: state.InToast,
  InToastLocation: state.InToastLocation,
  reportWindow: state.reportWindow
});

export default connect(mapStateToProps)(InToast1);
